import { useState } from 'react';
import { PaylinkCustomerInfo } from 'skipify-types';

import { toast } from '../../../util/toast';
import { useUpdatePaylinkCustomerMutation } from '../../../store/modules/merchant/api';
import { isServerError } from '../../../util/helpers';

type UseCustomerUpdateProps = {
  customerId: string;
};

export const useCustomerUpdate = ({ customerId }: UseCustomerUpdateProps) => {
  const [updatePaylinkCustomer, { isLoading }] = useUpdatePaylinkCustomerMutation();
  const [serverValidationError, setServerValidationError] = useState<string | undefined>(undefined);

  const onCustomerUpdate = async (updateCustomerBody: Partial<PaylinkCustomerInfo>) => {
    setServerValidationError(undefined);

    try {
      await updatePaylinkCustomer({
        ...updateCustomerBody,
        customerId,
      }).unwrap();
    } catch (err) {
      if (isServerError(err) && err.data.statusCode === 400) {
        setServerValidationError(err.data.message);
        throw new Error(err.data.message);
      }
      if (isServerError(err) && err.data.statusCode === 409) {
        setServerValidationError(
          'Customer already exists. Please try again using different customer information.',
        );
        throw new Error(err.data.message);
      }
      const errorMessage =
        'Something went wrong while updating the customer, please try again later';
      toast.error(errorMessage);
      throw err;
    }

    toast.success('Customer successfully edited.');
  };

  return {
    onCustomerUpdate,
    isLoading,
    serverValidationError,
    clearServerValidationError: () => setServerValidationError(undefined),
  };
};
